const RECEIVABLE_TYPES = {
  BTAPPLEPAY: 'btapplepay',
  BTPAYPAL: 'btpaypal',
  CREDIT_CARD: 'creditcard',
  PAYPAL: 'paypal',
  BTGOOGLEPAY: 'btandroidpay',
};

const CREDIT_CARD_TYPES = {
  AMERICAN_EXPRESS: 'AmericanExpress',
  MASTER_CARD: 'MasterCard',
  VISA: 'Visa',
};

const RECEIVABLE_ORDER = {
  [CREDIT_CARD_TYPES.VISA]: 0,
  [CREDIT_CARD_TYPES.MASTER_CARD]: 1,
  [CREDIT_CARD_TYPES.AMERICAN_EXPRESS]: 2,
  [RECEIVABLE_TYPES.PAYPAL]: 3,
  [RECEIVABLE_TYPES.BTPAYPAL]: 3,
  [RECEIVABLE_TYPES.BTAPPLEPAY]: 4,
  [RECEIVABLE_TYPES.BTGOOGLEPAY]: 5,
};

export {RECEIVABLE_TYPES, CREDIT_CARD_TYPES, RECEIVABLE_ORDER};
